// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"140":"8d83f0cf2f575519","321":"a7c74776037ac7f2"}[chunkId] + ".js";
};